export default "__VITE_ASSET__BaDu3Du7__"